import { useRef, useState } from "react";
import { empty, isString, toSentenceCase } from "../../Utilities/utils";
import { Toast } from "primereact/toast";

// css
import "../students/Students.css";
import "../dashboard/Dashboard.css";
import "../staff/Staff.css";

// components
import MainHeader from "../../components/headers/mainHeader/MainHeader";
import Card from "../../components/card/Card";
import { useContext } from "react";
import { AuthContext } from "../Root/ProtectedRoute";
import { Avatar } from "primereact/avatar";
import SettingsWrapper from "../../components/appWrapper/SettingsWrapper";

const Profile = ({ ...props }) => {
  const { user } = useContext(AuthContext);
  const toastTR = useRef(null);
  const firstName =
    !empty(user) && !empty(user.firstName) ? user.firstName : "---";
  const lastName =
    !empty(user) && !empty(user.lastName) ? user.lastName : "---";
  const fullName =
    !empty(user) && !empty(user.fullName) && isString(user.fullName)
      ? toSentenceCase(user.fullName)
      : "---";
  const firstNameInitial = firstName.charAt(0);
  const lastNameInitial = lastName.charAt(0);
  const middleName =
    !empty(user) && !empty(user.middleName) ? user.middleName : "---";
  const gender = !empty(user) && !empty(user.gender) ? user.gender : "---";
  const address = !empty(user) && !empty(user.address) ? user.address : "---";
  const stateOfResidence =
    !empty(user) && !empty(user.stateOfResidence)
      ? user.stateOfResidence
      : "---";
  const lgaOfResidence =
    !empty(user) && !empty(user.lgaOfResidence) ? user.lgaOfResidence : "---";
  const stateOfOrigin =
    !empty(user) && !empty(user.stateOfOrigin) ? user.stateOfOrigin : "---";
  const lgaOfOrigin =
    !empty(user) && !empty(user.lgaOfOrigin) ? user.lgaOfOrigin : "---";
  const nationality =
    !empty(user) && !empty(user.nationality) ? user.nationality : "---";
  const religion =
    !empty(user) && !empty(user.religion) ? user.religion : "---";
  const email = !empty(user) && !empty(user.email) ? user.email : "---";
  const dateOfBirth =
    !empty(user) && !empty(user.dateOfBirth) ? user.dateOfBirth : "---";
  const qrCodePath =
    !empty(user) && !empty(user.qrCodePath) ? user.qrCodePath : "";

  const avatar = !empty(user) && !empty(user.avatar) ? user.avatar : "";

  return (
    <>
      <SettingsWrapper {...props}>
        <main>
          {/* menu header */}
          <MainHeader title="Staff Profile" />
          {/* end menu header */}
          <div
            className="mt-10"
            style={{ display: "flex", flexDirection: "row" }}
          >
            {/* left box */}
            {/* chart */}
            <div className="chart_box">
              <Card
                children={
                  <>
                    <div className="dashboard_school_list">
                      <div className="avatar-container flex">
                        <div className="staff-avatar-container">
                          <p className="fs-20 bold">{fullName}</p>
                          {!empty(avatar) ? (
                            <Avatar
                              image={avatar}
                              shape="circle"
                              style={{
                                width: 200,
                                height: 200,
                                padding: 10,
                              }}
                              className="p-overlay-badge  mb-20"
                            ></Avatar>
                          ) : (
                            <Avatar
                              label={lastNameInitial + firstNameInitial}
                              shape="circle"
                              style={{
                                width: 150,
                                height: 150,
                                fontSize: 70,
                              }}
                              className="p-overlay-badge  mb-20"
                            ></Avatar>
                          )}
                        </div>
                        <div className="personal-info-block">
                          <div className="personal-info-list">
                            <div className="profile-title">First Name: </div>
                            <div className="profile-value">{firstName}</div>
                          </div>
                          <div className="personal-info-list">
                            <div className="profile-title">Last Name: </div>
                            <div className="profile-value">{lastName}</div>
                          </div>
                          <div className="personal-info-list">
                            <div className="profile-title">Middle Name: </div>
                            <div className="profile-value">{middleName}</div>
                          </div>
                          <div className="personal-info-list">
                            <div className="profile-title">Gender: </div>
                            <div className="profile-value">{gender}</div>
                          </div>
                          <div className="personal-info-list">
                            <div className="profile-title">Address: </div>
                            <div className="profile-value">{address}</div>
                          </div>
                        </div>
                        <div className="personal-info-block">
                          <div className="personal-info-list">
                            <div className="profile-title">
                              State of Residence:{" "}
                            </div>
                            <div className="profile-value">
                              {stateOfResidence}
                            </div>
                          </div>
                          <div className="personal-info-list">
                            <div className="profile-title">
                              L.G.A of Residence:{" "}
                            </div>
                            <div className="profile-value">
                              {lgaOfResidence}
                            </div>
                          </div>
                          <div className="personal-info-list">
                            <div className="profile-title">
                              State of Residence:{" "}
                            </div>
                            <div className="profile-value">{stateOfOrigin}</div>
                          </div>
                          <div className="personal-info-list">
                            <div className="profile-title">
                              L.G.A of Origin:{" "}
                            </div>
                            <div className="profile-value">{lgaOfOrigin}</div>
                          </div>
                          <div className="personal-info-list">
                            <div className="profile-title">Email: </div>
                            <div className="profile-value">{email}</div>
                          </div>
                        </div>
                      </div>
                      <div className="flex col-g-12">
                        <div className="personal-info-block">
                          <div className="personal-info-list">
                            <div className="profile-title">Nationality: </div>
                            <div className="profile-value">{nationality}</div>
                          </div>
                          <div className="personal-info-list">
                            <div className="profile-title">Religion</div>
                            <div className="profile-value">{religion}</div>
                          </div>
                          <div className="personal-info-list">
                            <div className="profile-title">Date of Birth</div>
                            <div className="profile-value">{dateOfBirth}</div>
                          </div>
                        </div>
                        <div className="personal-info-block">
                          <img
                            width={250}
                            height={250}
                            src={qrCodePath}
                            alt="qrcode"
                          />
                        </div>
                      </div>
                    </div>
                  </>
                }
                addStyle="student_list_box"
              />
            </div>
            {/* end chart */}
          </div>
        </main>
        <Toast ref={toastTR} position="bottom-left" />
      </SettingsWrapper>
    </>
  );
};

export default Profile;
